<template>
  <div id="app">
    <el-container style="height: 100vh; border: 1px solid #eee">
      <el-aside :width="isCollapse ? '64px' : '200px'" style="background-color: #545c64; height: 100vh; transition: width 0.3s;">
        <el-radio-group v-model="isCollapse" style="margin: 15px 0 15px 15px; display: inline-block; color: white;">
          <el-radio-button :label="false">展开</el-radio-button>
          <el-radio-button :label="true">收起</el-radio-button>
        </el-radio-group>
        
        <el-menu 
          default-active="dispatch"
          class="el-menu-vertical-demo" 
          @open="handleOpen" 
          @close="handleClose" 
          :collapse="isCollapse"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item index="table" @click="navigate('/table')">
            <i class="el-icon-menu"></i>
            <span slot="title">出货单</span>
          </el-menu-item>
          
          <el-submenu index="manage">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>管理</span>
            </template>
            <el-menu-item index="ManageCategory" @click="navigate('/ManageCategory')">
              <i class="el-icon-box"></i>
              <span>货物管理</span>
            </el-menu-item>
			<el-menu-item index="ManageStock" @click="navigate('/ManageStock')">
			  <i class="el-icon-box"></i>
			  <span>进货管理</span>
			</el-menu-item>
            <el-menu-item index="manage/accounts" @click="navigate('/ManageUser')">
              <i class="el-icon-user"></i>
              <span>账号管理</span>
            </el-menu-item>
            <el-submenu index="manage/other">
              <template slot="title">
                <i class="el-icon-more"></i>
                <span>其他管理</span>
              </template>
              <el-menu-item index="manage/porters" @click="navigate('/ManageCarry')">
                <i class="el-icon-loading"></i>
                <span>搬运</span>
              </el-menu-item>
              <el-menu-item index="manage/drivers" @click="navigate('/ManageDriver')">
                <i class="el-icon-truck"></i>
                <span>司机</span>
              </el-menu-item>
              <el-menu-item index="manage/ManageGround" @click="navigate('/ManageGround')">
                <i class="el-icon-location"></i>
                <span>装货地</span>
              </el-menu-item>
              <el-menu-item index="manage/ManageOwner" @click="navigate('/ManageOwner')">
                <i class="el-icon-user-solid"></i>
                <span>货主</span>
              </el-menu-item>
			  <el-menu-item index="manage/addresses" @click="navigate('/ManageAddr')">
			      <i class="el-icon-location"></i>
			      <span>地址</span>
			    </el-menu-item>
              <el-menu-item index="manage/orders" @click="navigate('/ManagePayee')">
                <i class="el-icon-document"></i>
                <span>挂单</span>
              </el-menu-item>
            </el-submenu>
          </el-submenu>
		  
		  <el-menu-item index="match" @click="navigate('/Match')">
		    <i class="el-icon-menu"></i>
		    <span slot="title">对账</span>
		  </el-menu-item>
		  
          <el-menu-item index="userinfo" @click="navigate('/Userinfo')">
            <i class="el-icon-s-custom"></i>
            <span slot="title">个人信息</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCollapse: false // 默认展开状态
    }
  },
  methods: {
    navigate(path) {
      // 获取当前路由路径
      const currentPath = this.$router.currentRoute.path;
      // 避免重复跳转
      if (currentPath !== path) {
        this.$router.push(path);
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  },
  name: 'App',
  components: {
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.full-screen {
  flex: 1;
  width: 100%;
  height: 100% !important;
}

.el-container {
  height: 100%;
  min-width: 100vw;
}

.el-aside {
  height: 100vh !important;
  transition: width 0.3s ease; /* 添加过渡效果 */
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
  min-height: 400px;
}

/* 自定义radio按钮样式 */
.el-radio-button__inner {
  background-color: transparent !important;
  border-color: #ffd04b !important;
  color: #ffd04b !important;
  font-size: 12px !important;
  padding: 8px 12px !important;
}

.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #ffd04b !important;
  color: #545c64 !important;
  box-shadow: -1px 0 0 0 #ffd04b !important;
}

/* 折叠状态下的radio按钮样式调整 */
.el-aside.el-menu--collapse .el-radio-button__inner {
  padding: 8px 6px !important;
  font-size: 10px !important;
}

/* 自定义滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #4a525a;
}

::-webkit-scrollbar-thumb {
  background: #8c939d;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a0a6ad;
}
</style>
